import Vue from 'vue';
import VueRouter from 'vue-router';

import ForgotPasswordConfirmationRoute from './routes/forgot-password-confirmation.route';
import ForgotPasswordRoute from './routes/forgot-password.route';
import LoginRoute from './routes/login.route';
import ResetPasswordRoute from './routes/reset-password.route';
import RootRoute from './routes/root.route';
import ChargeBeeRoute from './routes/chargebee.route';
import ChargeBeePurchaseCompleteRoute from './routes/chargebee-purchase-complete.route';
import SignUpRoute from './routes/signup.route';

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    ForgotPasswordConfirmationRoute,
    ForgotPasswordRoute,
    LoginRoute,
    ResetPasswordRoute,
    RootRoute,
    ChargeBeeRoute,
    ChargeBeePurchaseCompleteRoute,
    SignUpRoute,
  ],
});

Vue.use(VueRouter);
export default router;
